import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FormActions from '~myAccount/components/FormActions';
import PageLayout from '~myAccount/components/PageLayout';
import UserCardForm from '~/components/UserCardForm';
import { useFullRoutes, useQuery } from '~/hooks';
import { UserCardFormHandle } from '~/components/UserCardForm/types';
import ErrorMessage from '~/components/ErrorMessage';
import { RequestStatusEnum } from '~/constants/enums';
import { PaymentOperationTypeEnum } from '~/constants/enums/paymentEnums';

export default function AddUserCard() {
  const userCardFormRef = useRef<UserCardFormHandle>(null);
  const { t } = useTranslation('app');
  const { status } = useQuery();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string>();
  const { MY_ACCOUNT_URL } = useFullRoutes();

  const handleStatusFallback = () => {
    switch (status) {
      case RequestStatusEnum.FAILED:
        setError(t('somethingWrong'));
        break;
      case RequestStatusEnum.SUCCESS:
        window.location.href = MY_ACCOUNT_URL.USER_CARDS.ROOT;
        break;
    }
  };
  useEffect(() => {
    handleStatusFallback();
  }, [status]);

  return (
    <PageLayout
      title={t('savedCards')}
      bodyClassName="border border-gray rounded-[8px] py-3x"
    >
      <div className="flex flex-col gap-3x add-user-card-page px-2x md:px-3x">
        {error && <ErrorMessage message={error} />}
        <UserCardForm
          ref={userCardFormRef}
          onFailure={() => {
            setIsLoading(false);
            setError(t('somethingWrong'));
          }}
        />
        <FormActions
          isLoading={isLoading}
          disabled={isLoading}
          onSubmitBtnClick={() => {
            setIsLoading(true);
            userCardFormRef?.current?.submitUserCard({
              operationType: PaymentOperationTypeEnum.SAVE_CARD,
              returnTo: `${process.env.REACT_APP_BASE_URL}${MY_ACCOUNT_URL.USER_CARDS.ADD_CARD}`,
            });
          }}
        />
      </div>
    </PageLayout>
  );
}
